import { ADDEMAILLOG_SUCCESS, ADDEMAILLOG_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const addEmailLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDEMAILLOG_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ADDEMAILLOG_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default addEmailLogReducer;
